import { useMemo } from 'react'

import { useGetFeatureFlagsQuery } from 'app/services/api/featureFlags'

import { FeatureFlagsContext } from './FeatureFlagsContext'

export const FeatureFlagProvider = ({ children }: React.PropsWithChildren) => {
  const { data: flags = {} } = useGetFeatureFlagsQuery()

  const contextValue = useMemo(() => ({ flags }), [flags])

  return (
    <FeatureFlagsContext.Provider value={contextValue}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}
